import { LOAD_LIST_PAYMENT } from '../actionTypes';

const initialState = {
    paymentList: [],
    totalCount: 0,
    limit: 10,
    offset: 0,
    loading: false,
    error: '',
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_PAYMENT: {
            const { result, totalCount, limit, offset } = action.payload;

            return {
                ...state,
                paymentList: result,
                totalCount,
                limit, 
                offset
            }
        }

        default:
            return state
    }
}